export const isSameOrWrappedToken = (tokenSymbol: string, tokenSymbol2: string): boolean => {
  if (tokenSymbol === tokenSymbol2) {
    return true;
  }

  const isWrappedPair =
    (tokenSymbol === "ETH" && tokenSymbol2 === "WETH") ||
    (tokenSymbol === "WETH" && tokenSymbol2 === "ETH");

  return isWrappedPair;
};
